import { showConfirmModal } from "./custom_confirm"

// The profile-phone warning (issue #18649). Copy is fixed here, never taken
// from the server, so a response cannot inject markup. The server refuses the
// same number unless acknowledge_goat_number is sent after this returns true.

const TITLE = "This Is a GOAT Number, Not Your Personal Phone"
const LEAD = "This number belongs to GOAT. If you use it here:"
const BULLETS = [
  "Forwarded calls will stop ringing your cell. GOAT won't forward calls to a GOAT number (it would loop back), so those calls go to voicemail.",
  "New-lead alert texts will go to this GOAT number, not your phone.",
  "Login and verification codes will go there too, including the code to confirm this change.",
]
const CLOSING = "Your GOAT numbers are already used as your caller ID automatically. Keep your personal cell here."

function escapeHTML(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
}

function warningBody() {
  const items = BULLETS.map((item) => `<li>${escapeHTML(item)}</li>`).join("")
  return [
    `<p class="gl-modal-text">${escapeHTML(LEAD)}</p>`,
    `<ul class="mb-3">${items}</ul>`,
    `<p class="gl-modal-text mb-0">${escapeHTML(CLOSING)}</p>`,
  ].join("")
}

// True only for "Use GOAT Number Anyway". Keep, X, Esc, and a backdrop click
// resolve false: send nothing, leave the phone alone.
export function confirmGoatProfilePhone() {
  return showConfirmModal("", {
    title: TITLE,
    variant: "warning",
    confirmText: "Use GOAT Number Anyway",
    cancelText: "Keep My Current Number",
    cancelClass: "gl-btn gl-btn-primary",
    confirmFirst: true,
    focusRef: "cancel",
    scrollable: true,
    bodyHTML: warningBody(),
  })
}
